<template>
  <div class="iv-container">
    <div class="iv-content">
      <div class="iv-header">
        <Row>
          <Col span="18"><h4 class="iv-page-title">文化大事记</h4>
          </Col>
<!--          <Col span="6">
            <Form ref="formValidate">
              <FormItem>
                <Select v-model="formValidate.city" placeholder="Select your city">
                  <Option value="beijing">New York</Option>
                  <Option value="shanghai">London</Option>
                  <Option value="shenzhen">Sydney</Option>
                </Select>
              </FormItem>
            </Form>
          </Col>-->
        </Row>
      </div>
      <div class="iv-list-container" @mousewheel='showOut' v-if="newsList.length>0">
        <div class="iv-list" v-for="(item,index) in newsList" :key="item.id"
             v-show="activeIndex-index==1||activeIndex==index||index-activeIndex==1">
          <div class="iv-list-left" style="cursor: pointer" :class="index==activeIndex?'active':''" @click="getRouter(item.id)">
            <div class="iv-item-time">{{ timeFormat(item.whdsjReleaseTime) }}</div>
            <div class="iv-item-title">{{ item.title }}</div>
            <div class="iv-item-content" v-show="index==activeIndex" v-html="item.content">
<!--              {{ item.content }}-->
            </div>
          </div>

          <div class="iv-list-right" :class="index==activeIndex?'active':''">
            <img :src="getImgPath(item.blogPic)" alt="">
            <div class="iv-list-right-bg">
              <div class="iv-right-time">
                <p>{{ timeFormat(item.whdsjReleaseTime, 'MM月dd日') }}</p>
                <p>{{ timeFormat(item.whdsjReleaseTime, 'yyyy') }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="iv-list-center">
          <div class="center-pic"><img :src="getImgPath(newsList[activeIndex].blogPic)" alt=""></div>
          <div class="btn prev" @click="up()">˄</div>
          <div class="btn next" @click="down()">˅</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {timeFormat} from '@/utils'

export default {
  data() {
    return {
      formValidate: {
        city: '',
      },
      newsList: [],
      activeIndex: 0,
    }
  },
  mounted() {

  },
  created() {
    this.getList()
  },
  methods: {
    timeFormat,
    showOut(e) {
      if (e.wheelDelta) {  //判断浏览器IE，谷歌滑轮事件
        if (e.wheelDelta > 0) { //当滑轮向上滚动时
          // console.log('wheelDelta向上滚动')
          this.up()
        }
        if (e.wheelDelta < 0) {
          // console.log('wheelDelta向下滚动')
          this.down()
        }
      } else if (e.detail) {  //Firefox滑轮事件
        if (e.detail > 0) { //当滑轮向上滚动时
          // console.log('detail向上滚动')
          this.up()
        }
        if (e.detail < 0) {
          // console.log('detail向下滚动')
          this.down()
        }
      }
    },
    getImgPath(imageUrl) {
      return process.env.VUE_APP_BASE_DOWNLOAD_IMAGE_API + imageUrl
    },
    getRouter(id){
      this.$router.push('/newsDetail?infoId='+id)
    },
    up() {
      if (this.activeIndex == this.newsList.length - 1) {
        return false
      }
      this.activeIndex += 1
    },
    down() {
      if (this.activeIndex == 0) {
        return false
      }
      this.activeIndex -= 1
    },
    getList () {
      this.$ajax({
        url: 'api-qixuan/cms/front/getHome',
        method: 'get',
        data: {
          code: 'whdsj',
          rowNum: '50'
        }
      }).then(({data}) => {
        this.newsList = data.data.whdsj
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.iv-container {
  width: 100%;
  height: 100%;
  background: url("~@/assets/images/culture_bg.png") no-repeat;
  background-size: 100%;

  .iv-content {
    width: 1200px;
    margin: 20px auto 0 auto;


    .iv-page-title {
      height: 56px;
      line-height: 56px;
      font-size: 20px;
    }

    .iv-list-container {
      position: relative;

      .iv-list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 30px 0;
        position: relative;

        .iv-list-left {
          width: 560px;

          .iv-item-time {
            font-size: 16px;
            color: #99D7EF;
          }

          .iv-item-title {
            font-size: 20px;
            color: rgba(0, 0, 0, .4);
          }


          &.active {
            .iv-item-time {
              font-size: 20px;
              color: #009AD8;
            }

            .iv-item-title {
              font-size: 24px;
              color: rgba(0, 0, 0, .88);
            }

            .iv-item-content {
              font-size: 16px;
              color: rgba(0, 0, 0, 0.64);
            }
          }
        }


        .iv-list-right {
          position: relative;
          width: 160px;
          height: 160px;
          text-align: center;

          .iv-list-right-bg {
            background: rgba(0, 0, 0, 0.4);
            width: 120px;
            height: 120px;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }

          img {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            margin-top: 20px;
            object-fit: cover;
          }

          .iv-right-time {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            font-size: 16px;
            width: 100%;
            color: #fff;
          }

          &.active {
            .iv-list-right-bg {
              width: 160px;
              height: 160px;
            }

            img {
              width: 160px;
              height: 160px;
              margin: 0;
              object-fit: cover;
            }
          }
        }
      }

      .iv-list-center {
        position: absolute;
        left: 600px;
        top: 50%;
        transform: translateY(-50%);

        .center-pic {
          width: 320px;
          height: 320px;

          img {
            border-radius: 50%;
            width: 320px;
            height: 320px;
            object-fit: cover;
          }


        }

        .btn {
          position: absolute;
          width: 20px;
          height: 20px;
          cursor: pointer;
          right: -60px;
          font-size: 35pt;
          color: #dae6ef;
        }

        .btn:hover {
          color: #eee;
          transition: color 0.5s;
        }

        .prev {
          top: 110px;
        }

        .next {
          bottom: 110px;
        }
      }
    }
  }

  /deep/ .ivu-form-item {
    margin: 0 !important;
    margin-top: 10px !important;
  }
}

</style>
